import { ReactNode } from 'react';
import Key from 'types/Key';
import * as buttonStyles from '../styles/styles.module.scss';

type Props = {
  classes: string;
  dataTestId?: string;
  disabled: boolean;
  handler: (response?: any) => void;
  text: ReactNode;
  variant: string;
};

const SubmitButton = ({ text, handler = () => {}, variant = 'submit', classes, dataTestId = '', disabled = false }: Props) => {
  const onKeyPress = (event: any) => {
    if (event.key === Key.Enter) {
      handler();
    }
  };

  return (
    <div
      className={`${buttonStyles[variant]} ${classes}`}
      onKeyPress={!disabled && onKeyPress}
      onClick={!disabled && handler}
      tabIndex={0}
      role="button"
      data-testid={dataTestId}
    >
      {text}
    </div>
  );
};

SubmitButton.defaultProps = {
  classes: '',
  disabled: false
};

export default SubmitButton;
